//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {AppMixin} from "~/node_modules/sitis-nuxt/lib/mixins";

export default {
  name: "Stores",
  data() {
    return {
      imagesList: [],
      index: null,
      swiperStoresOptions: {
        freeMode: true,
        slidesPerView: 2.3,
        spaceBetween: 16,
        loop: false,
      },
    };
  },
  mixins: [AppMixin],
  methods: {
    onTapMarker(id) {
      this.$emit("onTapMarker", id);
    },
    getImagesList(store) {
      this.imagesList = [];
      const img = [
        this.$img(store.image_id.toString(), {width: 1900, quality: 90}),
      ];
      store.images_ids.forEach((t) => {
        img.push(this.$img(t.toString(), {width: 1900, quality: 90}));
      });
      this.$emit("isGalleryOpen");
      this.imagesList = img;
    },
    getImages(store) {
      // console.log(JSON.parse(store.images).map(t=>t.imageId))
      const images = [store.image_id];
      store.images_ids.forEach((t) => {
        images.push(t);
      });
      return images;
    },

    isActiveShop(storeId) {
      return Boolean(
        this.activeShop === storeId || (this.stores || []).length === 1
      );
    },
  },
  computed: {
    isShowQrCodeMessage() {
      return Boolean(
        (this.vars["Уведомление о QR-коде ВКЛ"] || "").toLowerCase() === "да"
      );
    },
  },
  emits: ["onTapMarker", "isGalleryOpen"],
  props: ["stores", "activeShop", "searchStore", "onChangeSearch"],
};
